import { render, staticRenderFns } from "./CovidHistoryTable.vue?vue&type=template&id=69f51b8a&scoped=true"
import script from "./CovidHistoryTable.vue?vue&type=script&lang=js"
export * from "./CovidHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./CovidHistoryTable.vue?vue&type=style&index=0&id=69f51b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f51b8a",
  null
  
)

export default component.exports